export type FeatureFlags = Record<never, never>

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {}

type FeatureFlagOverrides = Record<string, unknown>

export function parseFeatureFlags(raw: string | undefined): FeatureFlags {
  void raw
  return { ...DEFAULT_FEATURE_FLAGS }
}

export function mergeFeatureFlags(overrides: FeatureFlagOverrides | undefined): FeatureFlags {
  void overrides
  return { ...DEFAULT_FEATURE_FLAGS }
}

export function getFeatureFlags(overrides?: FeatureFlagOverrides): FeatureFlags {
  return applyStagingFeatureFlagHardcode(
    mergeFeatureFlags({
      ...parseFeatureFlags(import.meta.env.VITE_PROGETTO_ARCA_FEATURE_FLAGS),
      ...overrides,
    }),
  )
}

export function applyStagingFeatureFlagHardcode(
  flags: FeatureFlags,
  hostname = currentHostname(),
): FeatureFlags {
  void hostname
  return flags
}

function currentHostname(): string {
  return typeof window === 'undefined' ? '' : window.location.hostname
}
